/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-27 14:30:54
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Link, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import starsRedIcon from 'src/assets/images/common/stars-red.svg';

class PremiumLockBanner extends Component<Props> {
  render() {
    const { i18n, isSubscribeNow } = this.props;

    return (
      <div className="premium-lock-banner">
        <div className="detail">
          <img width={20} height={20} alt="pfs-star-icon" src={starsRedIcon} />
          <TextStyle variation="strong">
            {i18n.translate(`AdminHTML.TestYourSearch.PremiumFeature.content`)}
          </TextStyle>
        </div>
        <div className="action">
          <Link onClick={this.handleUnlock}>
            {i18n.translate(
              `AdminHTML.Common.Action.${isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'}`
            )}
          </Link>
        </div>
      </div>
    );
  }
  handleUnlock = () => {
    const { action, disableLockUnLock } = this.props;
    if (disableLockUnLock) {
      history.push(routes.subscription.plan());
    } else {
      action();
    }
  };
}

export default withI18n()(PremiumLockBanner);
